import { useApiCampaignActivityInfoImmutable } from '@hooks-api/fortune/useApiCampaignActivityInfoImmutable'
import { type Campaign } from '../model/campaign'
import { useCampaign } from './use-campaign'

export function useBrand() {
  const { campaignCodeFromUrl } = useCampaign()
  const { destructuredData: exhibitorSettings } = useApiCampaignActivityInfoImmutable(campaignCodeFromUrl)
  const brandMap = exhibitorSettings?.brand_codes_info.reduce<Record<string, Campaign['brand_codes_info'][number]>>((acc, cur) => {
    acc[cur.project_code] = cur
    return acc
  }, {})
  return {
    brandMap,
  }
}
